'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteQuotesOnSend = function (_Component) {
  (0, _inherits3.default)(DeleteQuotesOnSend, _Component);

  function DeleteQuotesOnSend(props) {
    (0, _classCallCheck3.default)(this, DeleteQuotesOnSend);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DeleteQuotesOnSend.__proto__ || (0, _getPrototypeOf2.default)(DeleteQuotesOnSend)).call(this, props));

    _this.handleCheckChange = _this.handleCheckChange.bind(_this);
    _this.handleRadioChange = _this.handleRadioChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DeleteQuotesOnSend, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // console.log('I, Configuration, will mount.')

      // fetch data. will propably need to go through the fetchEntitySaga.
      // so the fetch data logic will not go here, it will go in the saga,
      // all this will do is dispatch the necessary action by running the necessary
      // function.
    }
  }, {
    key: 'handleCheckChange',
    value: function handleCheckChange(e) {
      var changeProperty = this.props.changeProperty;

      changeProperty('deleteQuotesOnSend', e.target.checked);
    }
  }, {
    key: 'handleRadioChange',
    value: function handleRadioChange(e) {
      var changeProperty = this.props.changeProperty;

      changeProperty('deleteQuotesOnSendValue', e.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          value = _props.value;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _components.CategoryHeader,
          null,
          'Delete quotes on send'
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.line },
          _react2.default.createElement(_components.EnterpriseCheckBox, {
            checked: active,
            onChange: this.handleCheckChange,
            label: 'Delete quotes on send'
          })
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.line },
          _react2.default.createElement(_components.EnterpriseRadioButton, {
            checked: value === 'A',
            disabled: !active,
            name: 'quotes',
            onChange: this.handleRadioChange,
            label: 'All',
            value: 'A'
          }),
          _react2.default.createElement('div', { style: { width: '10px', display: 'inline-block' } }),
          _react2.default.createElement(_components.EnterpriseRadioButton, {
            checked: value === 'S',
            disabled: !active,
            name: 'quotes',
            onChange: this.handleRadioChange,
            label: 'Selected',
            value: 'S'
          })
        )
      );
    }
  }]);
  return DeleteQuotesOnSend;
}(_react.Component);

exports.default = DeleteQuotesOnSend;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DeleteQuotesOnSend/DeleteQuotesOnSend.jsx
// module id = 1453
// module chunks = 0